import AboutUs from "../About/Screens/AboutUs"
import Header from "../Home/Screens/Header"
import ContentFooter from "../Services/Screens/ContentFooter"


const AboutPage = () => {


    return (
        <div>
            <Header />
            <AboutUs />
            <ContentFooter />
        </div>
    )
}

export default AboutPage